import { render, staticRenderFns } from "./RegistrationRequestSuccess.vue?vue&type=template&id=02c2b007&scoped=true"
import script from "./RegistrationRequestSuccess.vue?vue&type=script&lang=js"
export * from "./RegistrationRequestSuccess.vue?vue&type=script&lang=js"
import style0 from "./RegistrationRequestSuccess.vue?vue&type=style&index=0&id=02c2b007&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c2b007",
  null
  
)

export default component.exports